<template>
  <div class="thankyou">

  </div>
</template>

<script>
import oauth from '../services/oauth.js'
import api from '../services/service.js'

export default {
  name: 'oauth',
  data () {
    return {
    }
  },
  methods: {
    async sendToken(updatedUser) {
      let router = this.$router;
      let state = JSON.parse(this.$route.query.state);

      console.log(updatedUser)

      if (state.attivazioneToken) {
        //associazione social
        let data = {
          token: state.attivazioneToken,
          provider: state.provider,
          oauth: updatedUser.accessToken
        };

        let res = await api.execute('post', 'utente/associaSocial', data, true);

        if(res.status === 200) // associato
        {
        }
        else
        {
          alert("Errore di associazione! Riprovare o contattare un amministratore!");
        }
      }

      let data = {
        token: updatedUser.accessToken,
        provider: state.provider
      };
      api.execute('post', 'oauth', data, true).then((data) => {
        if(state.redirect){
          router.push(state.redirect);
        }
        else{
          router.push({name: "Search"});
        }
      });
    }
  },
  async mounted() {
    let state = JSON.parse(this.$route.query.state);

    console.log("provider", state.provider);

    let provider = oauth.get(state.provider);

    let code = this.$route.query.code;
    let opt = { //because of Facebook
      query: {
        'code': code,
        'client_id': provider.options.clientId,
        'redirect_uri': provider.options.redirectUri,
        'client_secret': provider.options.clientSecret
      }
    };

    let sendToken = this.sendToken;

    provider.code.getToken(location.href, opt).then(function (user) {
      console.log(user);
      if(user.refreshToken){
        user.refresh().then(function (updatedUser) {
          sendToken(updatedUser);
        });
      }
      else {
        sendToken(user);
      }
    });
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/OAuth.vue